import { Injectable } from '@angular/core';
import { InvestigationPermission } from 'src/app/auth/domain/enums/investigation-permission.enum';
import { InvestigationRole } from 'src/app/auth/domain/enums/investigation-role.enum';
import { AuthorizationStateBase } from './authorization-state.base';

/**
 * State service for managing investigation management authorization data.
 * Provides type-safe access to user's investigation role and permissions.
 */
@Injectable({ providedIn: 'root' })
export class InvestigationAuthorizationState extends AuthorizationStateBase<InvestigationRole, InvestigationPermission> {}